import React, { useEffect, useState, useRef, useContext } from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useParams, Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import QRCode from 'qrcode.react';
import Barcode from 'react-barcode';
import LightModeIcon from '@mui/icons-material/LightMode';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { Switch, FormControlLabel, IconButton } from '@mui/material';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';
import { useDeadline } from '../../contexts/DeadlineContext';
import RequriedForEvent from './00RequriedForEvent'; // Adjust the path if needed

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

function Dashbord() {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const { offButton, getAbstractDeadLineStatus, refresh, triggerRefresh, runTheCodeData } = useDeadline();
    const [eventSingle, setEventSingle] = useState({});
    const [modules, setModules] = useState([]);
    const [reloadCounter, setReloadCounter] = useState(0);
    const [copied, setCopied] = useState(false);
    const [copiedModule, setCopiedModule] = useState(null);

    const history = useHistory()

    const gradientBackground = '#05597D';// Example gradient background
    const isSmallScreen = useMediaQuery('(max-width:600px)');

    useEffect(() => {

        console.log("Dashboard component re-rendered with refresh count:", refresh);
    }, [refresh]); // Log refresh count on every state update






    useEffect(() => {
        axios.get(`api/event/${id}`).then(res => {
            if (res.status === 200) {
                setEventSingle(res.data.event);
                const eventID = res.data.eventid;
                localStorage.setItem('eventid', eventID);
                localStorage.setItem('user_id', res.data.user_id);
                setLoading(false);
            } else {
                setLoading(false);
            }
        });
    }, [id]);
    const eventid = localStorage.getItem('eventid');
    useEffect(() => {
        if (reloadCounter < 5) {
            const organiserId = localStorage.getItem('user_id');

            axios.get(`api/modules-access/${eventid},${organiserId}`).then(res => {
                if (res.status === 200) {
                    setModules(res.data.mod);
                }
            });
            const timeoutId = setTimeout(() => {
                setReloadCounter(prevCounter => prevCounter + 1);
            }, 3000);
            return () => clearTimeout(timeoutId);
        }
    }, [reloadCounter]);
    localStorage.setItem('eventname', eventSingle.eventname);

    const onClickReload = () => {
        window.location.reload();
    };

    const role = localStorage.getItem('role');
    const abstractURL = `${window.location.origin}/#/abstract-author/${id}`;
    const exhibitionURL = `${window.location.origin}/#/exhibition/guest/${id}`;
    const workShopURL = `${window.location.origin}/#/workshop/registration/${id}`;
    const conferenceURL = `${window.location.origin}/#/conference/registration/${id}`;

    // const handleCopy = (url) => {
    //     navigator.clipboard.writeText(url).then(() => {
    //         setCopied(true);
    //         setTimeout(() => setCopied(false), 2000); // reset after 2s
    //     });
    // };

    const handleCopy = (text, moduleKey) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopiedModule(moduleKey);
            setTimeout(() => setCopiedModule(null), 2000);
        });
    };

    const downloadQRCode = (elementId, filename) => {
        const qrCodeURL = document.getElementById(elementId).toDataURL("image/png").replace("image/png", "image/octet-stream");
        const aEl = document.createElement("a");
        aEl.href = qrCodeURL;
        aEl.download = filename;
        document.body.appendChild(aEl);
        aEl.click();
        document.body.removeChild(aEl);
    };
    const elementId = 'barcodeAbstractCodeEl';
    const svgRef = useRef(null);

    const downloadBarcode = (filename) => {
        if (svgRef.current) {
            const svg = svgRef.current.outerHTML;
            const blob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
            const url = URL.createObjectURL(blob);

            const aEl = document.createElement("a");
            aEl.href = url;
            aEl.download = filename;

            document.body.appendChild(aEl);
            aEl.click();
            document.body.removeChild(aEl);
        } else {
            console.error(`Element with ref ${svgRef.current} not found.`);
        }
    };

    let backGroundButtonByEvent = "";

    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }


    return (
        <Box sx={{ padding: isSmallScreen ? 2 : 4, width: '100%' }} >
            <Grid container spacing={isSmallScreen ? 2 : 4}>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ color: "purple", marginTop: isSmallScreen ? "20%" : "3%" }}>
                    <Button sx={{
                        float: 'right',
                        marginTop: '0%',
                        background: abstractHomeSetup.color_code_two || gradientBackground,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'

                        onClick={() => history.goBack()} >
                        Back
                    </Button>
                    <Item>
                        <Typography variant={isSmallScreen ? "h5" : "h4"} gutterBottom>
                            Event  Dashboard
                        </Typography>

                    </Item>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} style={{ color: "purple", }}>
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <h4 sx={{ m: 2, color: '#000000' }}>
                                <Button
                                    sx={{ marginRight: '1%', float: 'right', ":hover": { color: "white" }, backgroundColor: backGroundButtonByEvent }}
                                    color='success'
                                    size='small'
                                    variant='contained'
                                    onClick={onClickReload}
                                >
                                    Refresh
                                </Button>
                            </h4>


                            {
                                role === 'organiser' && (
                                    <>
                                        <p style={{ marginLeft: "1%" }}>context component API: {runTheCodeData ? "On" : "OFF"}</p>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginLeft: '1%' }}>
                                            <Button
                                                sx={{
                                                    marginRight: '1%',
                                                    ":hover": { color: "white" },
                                                    backgroundColor: backGroundButtonByEvent,
                                                    display: 'flex', // Ensures the text and icon are aligned
                                                    alignItems: 'center',
                                                    gap: '8px' // Space between icon and text
                                                }}
                                                color='success'
                                                size='small'
                                                variant='contained'
                                                onClick={triggerRefresh}
                                            >
                                                {runTheCodeData ? <PauseIcon /> : <PlayArrowIcon />}
                                                {runTheCodeData ? "Stop Interval API" : "Start Interval API"}
                                            </Button>
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    display: 'inline-block',
                                                    width: 'fit-content',
                                                    height: 'fit-content',
                                                }}
                                            >
                                                <LightbulbIcon
                                                    sx={{ fontSize: 32 }}
                                                    style={{
                                                        color: runTheCodeData ? '#FFB300' : '#B0BEC5',
                                                        position: 'relative',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                {/* Rays effect */}
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: '40%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        width: '100%',
                                                        height: '100%',
                                                        borderRadius: '50%',
                                                        opacity: runTheCodeData ? 1 : 0,
                                                        pointerEvents: 'none',
                                                        zIndex: 0,
                                                        animation: runTheCodeData ? 'rays-animation 1.5s infinite' : 'none',
                                                    }}
                                                />
                                                <style>
                                                    {`
                                @keyframes rays-animation {
                                0% {
                                    box-shadow: 0 0 8px 0 rgba(255, 179, 0, 0.7), 0 0 12px 0 rgba(255, 179, 0, 0.5);
                                }
                                25% {
                                    box-shadow: 0 0 12px 5px rgba(255, 179, 0, 0.6), 0 0 20px 5px rgba(255, 179, 0, 0.4);
                                }
                                50% {
                                    box-shadow: 0 0 20px 10px rgba(255, 179, 0, 0.5), 0 0 30px 10px rgba(255, 179, 0, 0.3);
                                }
                                75% {
                                    box-shadow: 0 0 25px 15px rgba(255, 179, 0, 0.4), 0 0 40px 15px rgba(255, 179, 0, 0.2);
                                }
                                100% {
                                    box-shadow: 0 0 30px 20px rgba(255, 179, 0, 0.3), 0 0 50px 20px rgba(255, 179, 0, 0.1);
                                }
                                }
                            `}
                                                </style>
                                            </div>
                                        </div>
                                    </>

                                )}
                        </CardContent>
                    </Card>
                </Grid>
                {
                    role === 'organiser' && (
                        <>
                            <Grid item xs={12} sm={12} md={12} lg={12} style={{ color: "purple", marginTop: isSmallScreen ? "20%" : "3%" }}>
                                <Item>
                                    <Button
                                        sx={{
                                            background: abstractHomeSetup.color_code_two || gradientBackground,
                                            ":hover": {
                                                color: "white"
                                            }
                                        }}
                                        color='success'
                                        size='small'
                                        variant='contained'
                                        onClick={() => history.push('/admin/conference/requried-for-event')}>Requried For Event</Button>
                                </Item>
                            </Grid>
                        </>

                    )}
                {/* modulesSection */}
                <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
                    <Item>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12} lg={4}>
                                <Card sx={{ minWidth: 275 }}>
                                    <CardActions>
                                        <Button size="small">
                                            Conference Details
                                        </Button>
                                    </CardActions>
                                    <CardContent>
                                        <Typography variant="h5" component="div" >
                                            ID {eventSingle.id}
                                        </Typography>
                                        <Typography variant="body2" variant="h6" color="success.main" key={1} style={{ marginTop: '3%' }}>
                                            {eventSingle.eventname}
                                        </Typography>
                                    </CardContent>

                                </Card>
                            </Grid>
                            {modules.map((item, index) => (
                                <Grid item xs={12} sm={12} md={12} lg={4}>
                                    <Card sx={{ minWidth: 275 }}>
                                        <CardActions>
                                            <Button size="small">
                                                Module
                                            </Button>
                                        </CardActions>
                                        <CardContent>
                                            <Typography variant="h5" component="div">
                                                {eventSingle.eventname}
                                            </Typography>
                                            <Typography variant="body2" variant="h6" color="success.main" key={1}>
                                                {item?.title}
                                            </Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button size="small" component={Link} to="#">
                                                {(role === "author" && item.module === "AMS") && (
                                                    <Button
                                                        sx={{ mt: 4, backgroundColor: backGroundButtonByEvent }}
                                                        size="small"
                                                        variant="contained"
                                                        component={Link}
                                                        to="/admin/abstract/add-approve-article"
                                                    >
                                                        Submit Abstract
                                                    </Button>
                                                )}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}

                        </Grid>
                    </Item>
                </Grid>



                {/* RegistrationLinks Qrcodes */}
                {role === 'organiser' && (
                    <>
                        {modules.map((mod, index) => {
                            const module = mod.module;
                            return (
                                <React.Fragment key={index}>
                                    <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
                                        <Item>
                                            <Grid container spacing={2}>

                                                {/* Module Info (2 columns) */}
                                                <Grid item xs={12} sm={12} md={12} lg={4}>
                                                    <Card sx={{ minWidth: 275 }}>
                                                        <CardContent sx={{ mt: 2, mb: 1 }}>
                                                            <Typography variant="h5" component="div" sx={{ mb: 2 }}>
                                                                {module} Registration Link
                                                            </Typography>
                                                            <Typography variant="h6" color="success.main" sx={{ mb: 2 }}>
                                                                {eventSingle.eventname}
                                                            </Typography>

                                                            {module === 'AMS' && (
                                                                <Link href={abstractURL} target="_blank" rel="noopener" underline="hover">
                                                                    {abstractURL}
                                                                </Link>
                                                            )}
                                                            {module === 'EMS' && (
                                                                <Link href={exhibitionURL} target="_blank" rel="noopener" underline="hover">
                                                                    {exhibitionURL}
                                                                </Link>
                                                            )}
                                                            {module === 'WMS' && (
                                                                <Link href={workShopURL} target="_blank" rel="noopener" underline="hover">
                                                                    {workShopURL}
                                                                </Link>
                                                            )}
                                                            {module === 'PMS' && (
                                                                <Link href={conferenceURL} target="_blank" rel="noopener" underline="hover">
                                                                    {conferenceURL}
                                                                </Link>
                                                            )}
                                                        </CardContent>

                                                        <CardActions sx={{ display: 'flex', justifyContent: 'space-between', mt: 5 }}>
                                                            {/* Get Registration Link Button */}
                                                            {module === 'AMS' && (
                                                                <Button size="small" href={abstractURL} target="_blank" rel="noopener">
                                                                    Get Registration Link
                                                                </Button>
                                                            )}
                                                            {module === 'EMS' && (
                                                                <Button size="small" href={exhibitionURL} target="_blank" rel="noopener">
                                                                    Get Registration Link
                                                                </Button>
                                                            )}
                                                            {module === 'WMS' && (
                                                                <Button size="small" href={workShopURL} target="_blank" rel="noopener">
                                                                    Get Registration Link
                                                                </Button>
                                                            )}
                                                            {module === 'PMS' && (
                                                                <Button size="small" href={conferenceURL} target="_blank" rel="noopener">
                                                                    Get Registration Link
                                                                </Button>
                                                            )}

                                                            {/* Copy Icon Button */}

                                                            <Box display="flex" alignItems="center" gap={1} sx={{ mt: 1 }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ color: copiedModule === module ? 'success.main' : 'text.primary' }}
                                                                >
                                                                    {copiedModule === module ? 'Copied!' : 'Copy Registration Link'}
                                                                </Typography>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        const url =
                                                                            module === 'AMS'
                                                                                ? abstractURL
                                                                                : module === 'EMS'
                                                                                    ? exhibitionURL
                                                                                    : module === 'WMS'
                                                                                        ? workShopURL
                                                                                        : conferenceURL;

                                                                        handleCopy(url, module);
                                                                    }}
                                                                    color={copiedModule === module ? 'success' : 'default'}
                                                                >
                                                                    <CopyAllIcon
                                                                        fontSize="small"
                                                                        color={copiedModule === module ? 'success' : 'action'}
                                                                    />
                                                                </IconButton>


                                                            </Box>
                                                        </CardActions>
                                                    </Card>
                                                </Grid>



                                                {/* QR Code (4 columns) */}
                                                <Grid item xs={12} sm={12} md={12} lg={4}>
                                                    <Card sx={{ minWidth: 275 }}>
                                                        <CardContent>
                                                            <Typography variant="h6" sx={{ mt: 1, mb: 1 }}>
                                                                QR Code
                                                            </Typography>
                                                            {module === 'AMS' && <QRCode id="qrAMS" value={abstractURL} size={128} />}
                                                            {module === 'EMS' && <QRCode id="qrEMS" value={exhibitionURL} size={128} />}
                                                            {module === 'WMS' && <QRCode id="qrWMS" value={workShopURL} size={128} />}
                                                            {module === 'PMS' && <QRCode id="qrPMS" value={conferenceURL} size={128} />}
                                                            {module === 'MMS' && <QRCode id="qrPMS" value={conferenceURL} size={128} />}
                                                        </CardContent>
                                                        <CardActions sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                            {module === 'AMS' && (
                                                                <>

                                                                    {
                                                                        isSmallScreen ? (
                                                                            <Button
                                                                                onClick={() => downloadQRCode("qrAMS", 'abstract-qr-code.png')}
                                                                                variant="contained"
                                                                                color="success"

                                                                                sx={{
                                                                                    backgroundColor: backGroundButtonByEvent,
                                                                                    ":hover": { color: "white" },
                                                                                    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
                                                                                    px: { xs: 1.5, sm: 2, md: 2.5 },
                                                                                    py: { xs: 0.5, sm: 0.75 },
                                                                                    minWidth: { xs: 'unset', sm: 'auto' }
                                                                                }}
                                                                            >
                                                                                <DownloadIcon />
                                                                            </Button>
                                                                        ) :
                                                                            <Button
                                                                                onClick={() => downloadQRCode("qrAMS", 'abstract-qr-code.png')}
                                                                                variant="contained"
                                                                                color="success"
                                                                                size="small"
                                                                                startIcon={<DownloadIcon />}
                                                                                sx={{ marginRight: '1%', float: 'right', ":hover": { color: "white" }, backgroundColor: backGroundButtonByEvent }}
                                                                            >
                                                                                Download QR Code
                                                                            </Button>
                                                                    }


                                                                    {/* Wrapping the button and icon inside a Box for alignment */}
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                        <Button
                                                                            size="small"
                                                                            onClick={() => {
                                                                                handleCopy(abstractURL, 'AMS');
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            {copiedModule === 'AMS' ? 'Copied!' : 'Copy Registration Link'}
                                                                        </Button>

                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => {
                                                                                handleCopy(abstractURL, 'AMS');
                                                                            }}
                                                                            color={copiedModule === 'AMS' ? 'success' : 'default'}
                                                                        >
                                                                            <CopyAllIcon fontSize="small" color={copiedModule === 'AMS' ? 'success' : 'action'} />
                                                                        </IconButton>
                                                                    </Box>
                                                                </>
                                                            )}
                                                            {module === 'EMS' && (
                                                                <>
                                                                    {
                                                                        isSmallScreen ? (
                                                                            <Button
                                                                                onClick={() => downloadQRCode("qrEMS", 'exhibition-qr-code.png')}
                                                                                variant="contained"
                                                                                color="success"
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: backGroundButtonByEvent,
                                                                                    ":hover": { color: "white" },

                                                                                }}
                                                                            >
                                                                                <DownloadIcon />
                                                                            </Button>
                                                                        ) :
                                                                            <Button
                                                                                onClick={() => downloadQRCode("qrEMS", 'exhibition-qr-code.png')}
                                                                                variant="contained"
                                                                                color="success"
                                                                                size="small"
                                                                                startIcon={<DownloadIcon />}
                                                                                sx={{
                                                                                    backgroundColor: backGroundButtonByEvent,
                                                                                    ":hover": { color: "white" },
                                                                                    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },

                                                                                }}
                                                                            >
                                                                                Download QR Code
                                                                            </Button>

                                                                    }

                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                        <Button
                                                                            size="small" onClick={() => {
                                                                                handleCopy(exhibitionURL, 'EMS');
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            {copiedModule === 'EMS' ? 'Copied!' : 'Copy Registration Link'}
                                                                        </Button>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => {
                                                                                handleCopy(exhibitionURL, 'EMS');
                                                                            }}
                                                                            color={copiedModule === 'EMS' ? 'success' : 'default'}
                                                                        >
                                                                            <CopyAllIcon fontSize="small" color={copiedModule === 'EMS' ? 'success' : 'action'} />
                                                                        </IconButton>
                                                                    </Box>
                                                                </>

                                                            )}
                                                            {module === 'WMS' && (
                                                                <>
                                                                    {
                                                                        isSmallScreen ? (
                                                                            <Button
                                                                                onClick={() => downloadQRCode("qrWMS", 'workshop-qr-code.png')}
                                                                                variant="contained"
                                                                                color="success"
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: backGroundButtonByEvent,
                                                                                    ":hover": { color: "white" },

                                                                                }}
                                                                            >
                                                                                <DownloadIcon />
                                                                            </Button>
                                                                        ) :
                                                                            <Button
                                                                                onClick={() => downloadQRCode("qrWMS", 'workshop-qr-code.png')}
                                                                                variant="contained"
                                                                                color="success"
                                                                                size="small"
                                                                                startIcon={<DownloadIcon />}
                                                                                sx={{
                                                                                    backgroundColor: backGroundButtonByEvent,
                                                                                    ":hover": { color: "white" },

                                                                                }}
                                                                            >
                                                                                Download QR Code
                                                                            </Button>
                                                                    }

                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                        <Button
                                                                            size="small"
                                                                            onClick={() => {
                                                                                handleCopy(workShopURL, 'WMS');
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            {copiedModule === 'WMS' ? 'Copied!' : 'Copy Registration Link'}
                                                                        </Button>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => {
                                                                                handleCopy(workShopURL, 'WMS');
                                                                            }}
                                                                            color={copiedModule === 'WMS' ? 'success' : 'default'}
                                                                        >
                                                                            <CopyAllIcon fontSize="small" color={copiedModule === 'WMS' ? 'success' : 'action'} />
                                                                        </IconButton>
                                                                    </Box>
                                                                </>
                                                            )}
                                                            {module === 'PMS' && (
                                                                <>
                                                                    {
                                                                        isSmallScreen ? (
                                                                            <Button
                                                                                onClick={() => downloadQRCode("qrPMS", 'conference-qr-code.png')}
                                                                                variant="contained"
                                                                                color="success"
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: backGroundButtonByEvent,
                                                                                    ":hover": { color: "white" },

                                                                                }}
                                                                            >
                                                                                <DownloadIcon />
                                                                            </Button>
                                                                        ) :
                                                                            <Button
                                                                                onClick={() => downloadQRCode("qrPMS", 'conference-qr-code.png')}
                                                                                variant="contained"
                                                                                color="success"
                                                                                size="small"
                                                                                startIcon={<DownloadIcon />}
                                                                                sx={{
                                                                                    backgroundColor: backGroundButtonByEvent,
                                                                                    ":hover": { color: "white" },

                                                                                }}
                                                                            >
                                                                                Download QR Code
                                                                            </Button>

                                                                    }
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                        <Button
                                                                            size="small"
                                                                            onClick={() => {
                                                                                handleCopy(conferenceURL, 'PMS');
                                                                            }}
                                                                            color="primary"
                                                                        >
                                                                            {copiedModule === 'PMS' ? 'Copied!' : 'Copy Registration Link'}
                                                                        </Button>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => {
                                                                                handleCopy(conferenceURL, 'PMS');
                                                                            }}
                                                                            color={copiedModule === 'PMS' ? 'success' : 'default'}
                                                                        >
                                                                            <CopyAllIcon fontSize="small" color={copiedModule === 'PMS' ? 'success' : 'action'} />
                                                                        </IconButton>
                                                                    </Box>
                                                                </>

                                                            )}
                                                        </CardActions>
                                                    </Card>
                                                </Grid>

                                                {/* Barcode + Copy Registration Link (6 columns) */}
                                                <Grid item xs={12} sm={12} md={12} lg={4} sx={{ display: { xs: 'none', sm: 'block' } }}>
                                                    <Card sx={{ minWidth: 275 }}>
                                                        <CardContent>
                                                            <Typography variant="h6">Barcode</Typography>
                                                            {module === 'AMS' && <Barcode ref={svgRef} format="CODE128" width={1} fontSize={10} value={abstractURL} />}
                                                            {module === 'EMS' && <Barcode ref={svgRef} format="CODE128" width={1} fontSize={10} value={exhibitionURL} />}
                                                            {module === 'WMS' && <Barcode ref={svgRef} format="CODE128" width={1} fontSize={10} value={workShopURL} />}
                                                            {module === 'PMS' && <Barcode ref={svgRef} format="CODE128" width={1} fontSize={10} value={conferenceURL} />}
                                                            {module === 'MMS' && <Barcode ref={svgRef} format="CODE128" width={1} fontSize={10} value={conferenceURL} />}
                                                        </CardContent>
                                                        <CardActions sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                            <Button
                                                                size="small"
                                                                sx={{ ":hover": { color: "white" }, backgroundColor: backGroundButtonByEvent }}
                                                                color='success'
                                                                size='small'
                                                                variant='contained'
                                                                onClick={() =>
                                                                    downloadBarcode(`${module.toLowerCase()}-barcode.svg`)
                                                                }
                                                            >
                                                                Download Barcode
                                                            </Button>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                {/* Copy actual registration link */}
                                                                <Button
                                                                    size="small"

                                                                    onClick={() => {


                                                                        const baseURL = window.location.origin;
                                                                        const pathMap = {
                                                                            'AMS': abstractURL,
                                                                            'EMS': exhibitionURL,
                                                                            'WMS': workShopURL,
                                                                            'PMS': conferenceURL,
                                                                        };
                                                                        const fullURL = baseURL + pathMap[module];
                                                                        handleCopy(fullURL, module);
                                                                    }}
                                                                    color="primary"
                                                                >
                                                                    {copiedModule === module ? 'Copied!' : 'Copy Registration Link'}
                                                                </Button>

                                                                {/* QR/Barcode Raw Value Copy */}
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        const urlMap = {
                                                                            'AMS': abstractURL,
                                                                            'EMS': exhibitionURL,
                                                                            'WMS': workShopURL,
                                                                            'PMS': conferenceURL,
                                                                        };
                                                                        handleCopy(urlMap[module], module);
                                                                    }}
                                                                    color={copiedModule === module ? 'success' : 'default'}
                                                                >
                                                                    <CopyAllIcon fontSize="small" color={copiedModule === module ? 'success' : 'action'} />
                                                                </IconButton>
                                                            </Box>
                                                        </CardActions>
                                                    </Card>
                                                </Grid>

                                            </Grid>
                                        </Item>
                                    </Grid>
                                </React.Fragment>
                            );
                        })}
                    </>
                )}


            </Grid>

        </Box>
    );
}

export default Dashbord;
